import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, GlobeIcon, LockIcon, ZapIcon } from 'lucide-react';
export function AboutSection() {
  const features = [{
    icon: GlobeIcon,
    title: 'UAE-Based',
    description: "Serving the region's growing security needs"
  }, {
    icon: ShieldCheckIcon,
    title: 'Trusted Brands',
    description: 'Partnering with global security leaders'
  }, {
    icon: LockIcon,
    title: 'Privacy First',
    description: 'Built for discretion and resilience'
  }, {
    icon: ZapIcon,
    title: 'Future Ready',
    description: 'Cutting-edge solutions for modern threats'
  }];
  return <section id="about" className="py-20 px-6 relative overflow-hidden bg-gradient-to-br from-[#0B1220] to-[#1e293b]" data-id="element-22">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-23" />
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-25">
          <h2 className="text-4xl font-bold text-white mb-6" data-id="element-26">
            About GrapeSkin
          </h2>
          <div className="max-w-3xl mx-auto space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-27">
            <p data-id="element-28">
              At GrapeSkin, we protect what matters most: your data, your
              privacy, your digital freedom. Based in the UAE and serving the
              region's growing demand for personal and professional security, we
              offer cutting-edge hardware and privacy accessories built for the
              modern world — from encrypted drives and secure phones to
              RFID-shielded wallets and Faraday gear.
            </p>
            <p data-id="element-29">
              We work with leading global brands that share our mission:
              empowering individuals and businesses to stay secure in a
              hyperconnected world. Whether you're a traveler, a tech-pro, or a
              privacy-first professional, GrapeSkin delivers tools you can trust
              — designed for discretion, built for resilience, and ready for the
              future.
            </p>
            <p className="text-xl font-semibold text-white" data-id="element-30">
              Privacy is power. Security is non-negotiable. Choose GrapeSkin.
            </p>
          </div>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12" data-id="element-31">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-all" data-id="element-32">
              <div className="w-12 h-12 bg-gradient-to-br from-[#3B82F6] to-[#10B981] rounded-lg flex items-center justify-center mb-4" data-id="element-33">
                <feature.icon className="w-6 h-6 text-white" data-id="element-34" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-35">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-300" data-id="element-36">{feature.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}